import Splide from '@splidejs/splide';

export default function tabsMedia() {

    // console.log('Tabs Media initialized');

    const blocks = document.querySelectorAll('.tabs-media');

    if (blocks.length === 0) return;

    blocks.forEach(block => {
        const carouselEl = block.querySelector('.tabs-media__carousel');
        const splideEl = carouselEl?.querySelector('.splide');
        const buttons = block.querySelectorAll('.tabs-media__btn');

        if (!splideEl) return;

        const startIndex = parseInt(carouselEl.dataset.start || '0', 10);

        const splide = new Splide(splideEl, {
            type: 'fade',
            rewind: true,
            pagination: false,
            arrows: false,
            drag: false,
            start: startIndex,
        });

        splide.mount();

        // Update active button when slide changes
        splide.on('move', (newIndex) => {
            buttons.forEach((btn, i) => {
                const isActive = i === newIndex;
                btn.classList.toggle('is-active', isActive);
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            });
        });

        // Navigate to slide on button click
        buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
                const index = parseInt(btn.dataset.index, 10);
                splide.go(index);
            });
        });
    });

}
